export enum PaymentState {
    Succeeded,
    Failed,
    Canceled,
    Expired,
    Refunded,
    Reserved,
    NotStarted,
}
